<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-date-picker
              v-model="startDate"
              type="date"
              placeholder="开始日期"
              value-format="yyyy-MM-dd"	
              >
          </el-date-picker>
          <el-date-picker
              v-model="endDate"
              type="date"
              placeholder="结束日期"
              value-format="yyyy-MM-dd"	
              >
          </el-date-picker>
        </div>  
        <div style='display:inline-block;'>
          <el-input placeholder="ID/会员名/手机号码" v-model="keywords" class="input-with-select" @change='getList()'>
                    <el-select v-model="type" slot="prepend" placeholder="积分类型">
                      <el-option label="个体护持"   value="1"></el-option>
                      <el-option label="平跨级" value="2"></el-option>
                      <el-option label="业绩" value="3"></el-option>
                      <el-option label="二赠一差价" value="4"></el-option>
                      <el-option label="发货积分" value="5"></el-option>
                      <el-option label="邀约积分" value="6"></el-option>
                      <el-option label="实体积分" value="7"></el-option>
                    </el-select>
                    <el-button slot="append" icon="el-icon-search" @click='getList()'></el-button>
          </el-input>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        label="产生时间">
      <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}
      </template>
      </el-table-column>
      <el-table-column
        prop="username"
        label="奖励人">
      </el-table-column>
      <el-table-column
        label="积分类型">
        <template slot-scope="scope"> 
          <span v-if="scope.row.type==1">个体护持积分</span><span v-else-if="scope.row.type==2">平跨级积分</span><span v-else-if="scope.row.type==3">业绩积分</span><span v-else-if="scope.row.type==4">差价积分</span><span v-else-if="scope.row.type==5">发货积分</span><span v-else-if="scope.row.type==6">邀约积分</span><span v-else-if="scope.row.type==7">实体积分</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="points"
        label="积分值">
      </el-table-column>
      <el-table-column
        prop="from"
        label="来源">
      </el-table-column>
      <el-table-column
        label="兑换状态">
        <template slot-scope="scope"> 
          <el-tag type="success" v-if="scope.row.ispay==1">已兑换</el-tag>  <el-tag type="info" v-else-if="scope.row.ispay==0">未兑换</el-tag> 
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
   </div> 
</template>

<script>
export default {
  data(){
     return {
        tableData:[],
        startDate:'',
        endDate:'',
        type:'',
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        }
     }
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/prize/getPrizeDetail",{pageinfo:this.pageinfo,startdate:this.startDate,enddate:this.endDate,keywords:this.keywords,type:this.type}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.prizedetail
                  this.pageinfo=data.result.info.pageinfo 
               }else{
                  this.$message.error(data.result.info)
               }
          })
      }
  }
}
</script>

<style scoped lang="scss">
.order-detail {font-size:14px;}
.order-detail li{padding: 0.1rem;list-style-type:none;border-bottom: 1px dashed #ccc;}
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
</style>
